"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const faLockKeyhole_1 = require("@fortawesome/pro-solid-svg-icons/faLockKeyhole");
const createIcon_1 = __importDefault(require("./utils/createIcon"));
const LockKeyholeIcon = (0, createIcon_1.default)({
    displayName: 'LockKeyhole',
    title: 'Lock Keyhole icon',
    icon: faLockKeyhole_1.faLockKeyhole,
});
exports.default = LockKeyholeIcon;
